export default __webpack_public_path__ + "ba177eb211ce3f484bac59e1a380adce.mp3";